import { render, staticRenderFns } from "./ExportListData.vue?vue&type=template&id=fa88fba6&scoped=true"
import script from "./ExportListData.vue?vue&type=script&lang=js"
export * from "./ExportListData.vue?vue&type=script&lang=js"
import style0 from "./ExportListData.vue?vue&type=style&index=0&id=fa88fba6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa88fba6",
  null
  
)

export default component.exports